// global
import React from 'react';
import { PropTypes } from 'prop-types';
import MaskedInput from 'react-text-mask';
// utils
import { ZIP_MASK } from 'app/utils/formUtils/masks';
// components
import { Form, Icon } from 'semantic-ui-react';
// import ErrorLabel from 'app/components/commons/label/ErrorLabel';
import CustomSearch from 'app/components/commons/search/CustomSearch';

function CEPSearch(props) {
  const { label, /* errors, */ placeholder, required } = props;
  const { width, value, onChange, error } = props;
  const { searching, readOnly, onFocus } = props;

  return (
    <CustomSearch
      style={{ border: 'none' }}
      input={
        <Form.Field>
          <Form.Input
            label={label}
            placeholder={placeholder}
            required={required}
            control={MaskedInput}
            mask={ZIP_MASK}
            width={width}
            value={value}
            onChange={onChange}
            error={error}
            disabled={searching}
            readOnly={readOnly}
            onFocus={onFocus}
          />
          <Icon
            name={searching ? 'circle notch' : 'search'}
            loading={searching}
            style={{ position: 'relative', margin: 0, top: '-50%', left: '80%' }}
          />
        </Form.Field>
      }
      handleSearchChange={() => {}}
      showNoResults={false}
      styleName={'styleDefaultSearch3'}
    />
  );
}

CEPSearch.propTypes = {
  searching: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  errors: PropTypes.object,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  width: PropTypes.number,
  readOnly: PropTypes.bool,
  onFocus: PropTypes.func,
  isForm: PropTypes.bool
};

CEPSearch.defaultProps = {
  label: 'CEP',
  placeholder: 'CEP'
};

export default CEPSearch;
